/*
 * @Author: Hong.Zhang
 * @Date: 2024-12-10 17:32:30
 * @Description:
 */
import * as Sentry from '@sentry/react';
import { getProductName } from './store';
import { APP_VERSION } from './version';

export const initSentry = (kredivoUserId: string) => {
  if (ENV !== 'local') {
    Sentry.init({
      dsn: 'https://3c43af2c633146df93d0c88ab0d4bbe3@sentry.dev.iglooinsure.com/9',
      release: APP_VERSION,
      environment: ENV,
      beforeSend(event) {
        const originExtra = event.extra;
        event.extra = {
          ...originExtra,
          productName: getProductName(),
          kredivoUserId: kredivoUserId,
        };
        return event;
      },
    });
  }
};
